import { useEffect, useState } from 'react';
import { Loader2, Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { showApiErrorToast } from '@/utils/errors';

const NO_PRINT_REQUEST = 0;

interface PrintButtonProps {
  onBeforePrint?: (() => Promise<void>) | undefined;
  disabled?: boolean | undefined;
}

export function PrintButton({ onBeforePrint, disabled }: PrintButtonProps) {
  const [isPreparing, setIsPreparing] = useState(false);
  const [printRequestCount, setPrintRequestCount] = useState(NO_PRINT_REQUEST);

  useEffect(() => {
    if (printRequestCount === NO_PRINT_REQUEST) return;
    window.print();
  }, [printRequestCount]);

  async function handleClick() {
    setIsPreparing(true);
    try {
      await onBeforePrint?.();
      setPrintRequestCount((count) => count + 1);
    } catch (error) {
      showApiErrorToast(error, 'Could not load every row to print');
    } finally {
      setIsPreparing(false);
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      className="gap-2"
      onClick={() => void handleClick()}
      disabled={disabled || isPreparing}
    >
      {isPreparing ? <Loader2 className="size-4 animate-spin" /> : <Printer className="size-4" />}
      Print
    </Button>
  );
}
